import React, { useContext, useEffect, useState } from 'react';
import '../contacts/Contact.css';
import {
	// Button,
	TextField,
	Typography,
	IconButton,
	Dialog,
	// DialogActions,
	DialogContent,
	DialogTitle,
	Container,
	Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import 'react-toastify/dist/ReactToastify.css';
import { GridColDef, GridValueGetter, GridToolbar } from '@mui/x-data-grid';
import CreateContacts from './CreateWholesale';
import { getAllWholesale } from '../../../services/api/Wholesale';
import { StyledCrossIconButton, StyledDataGrid } from '../../component/ThemeComponent';
import userContext from '../../../configs/context/context';

interface CustomField {
	fieldType: 'text' | 'file';
	fieldName: string;
	filePath?: string;
	fieldValue?: string;
	_id?: string;
}

interface ContactCardProps {
	_id: string;
	productId: string;
	quantity: number;
	fullName: string;
	email: string;
	mobileNo: string;
	message: string;
	status: number;
	followupStatus: string;
	Notification: boolean;
	createdBy: string;
	createdAt: string;
	updatedAt: string;
	customFields: CustomField[];
}

interface GridRowParams {
	row: ContactCardProps;
}

const Wholesalepage = () => {
	const [contacts, setContacts] = useState<ContactCardProps[]>([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [openDialog, setOpenDialog] = useState(false);
	const [currentProduct, setCurrentProduct] = useState<ContactCardProps | null>(null);
	const [visibleEnquiry, setVisibleEnquiry] = useState(true);
	const { Vendorme } = useContext<any>(userContext);
	const permmission = Vendorme?.permissions?.wholesale;
	const slug = localStorage.getItem('slug');
	const location = window.location.pathname.split('/');

	const handleEditProduct = (product: ContactCardProps) => {
		setCurrentProduct(product);
		setOpenDialog(true);
		setVisibleEnquiry(true);
	};

	const handleVisibleProduct = (product: ContactCardProps) => {
		setCurrentProduct(product);
		setOpenDialog(true);
		setVisibleEnquiry(false);
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
		setCurrentProduct(null);
	};

	// const handleSaveContact = () => {
	// 	const form = document.getElementById('create-contact-form') as HTMLFormElement;
	// 	if (form) {
	// 		form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
	// 	}
	// };

	// const handleFormSubmit = async (formData: ContactCardProps): Promise<void> => {
	// 	const { fullName, email, mobileNo, message, followupStatus, quantity, customFields } =
	// 		formData;

	// 	const dataToSend = new FormData();
	// 	dataToSend.append('fullName', fullName);
	// 	dataToSend.append('email', email);
	// 	dataToSend.append('mobileNo', mobileNo);
	// 	dataToSend.append('message', message);
	// 	dataToSend.append('followupStatus', followupStatus);
	// 	dataToSend.append('quantity', quantity.toString());

	// 	customFields.forEach((field) => {
	// 		if (field.fieldType === 'file' && field.filePath) {
	// 			dataToSend.append(field.fieldName, field.filePath);
	// 		} else if (field.fieldType === 'text' && field.fieldValue) {
	// 			dataToSend.append(field.fieldName, field.fieldValue);
	// 		}
	// 	});

	// 	try {
	// 		const response = await updateWholesale(dataToSend, formData._id);
	// 		if (response.success) {
	// 			fetchData();
	// 			setOpenDialog(false);
	// 			toast.success('Contact updated successfully!');
	// 		} else {
	// 			toast.error('Failed to update contact.');
	// 		}
	// 	} catch (error) {
	// 		toast.error('Error updating contact.');
	// 	}
	// };

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			const response = await getAllWholesale();
			if (response.success) {
				setContacts(response?.data?.wholesales);
			}
		} catch (e) {
			console.log(e);
		}
	};

	const filteredContacts = contacts
		.reverse()
		.filter(
			(contact) =>
				contact.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
				contact.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
				contact.mobileNo?.toLowerCase().includes(searchTerm.toLowerCase())
		);

	const createdAtDate: GridValueGetter<(typeof contacts)[number], unknown> = (value, row) =>
		`${
			new Date(row.createdAt)
				.toLocaleString('en-GB', {
					day: '2-digit',
					month: 'short',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				})
				.replace(/,/g, '')
				.replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+) (AM|PM)/, '$1-$2-$3 $4 $5') || 'N/A'
		}`;

	const updatedAtDate: GridValueGetter<(typeof contacts)[number], unknown> = (value, row) =>
		`${
			new Date(row.updatedAt)
				.toLocaleString('en-GB', {
					day: '2-digit',
					month: 'short',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				})
				.replace(/,/g, '')
				.replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+) (AM|PM)/, '$1-$2-$3 $4 $5') || 'N/A'
		}`;

	const columns: GridColDef[] = [
		{ field: 'fullName', headerName: 'Full Name', width: 150, type: 'string' },
		{ field: 'email', headerName: 'Email', width: 200, type: 'string' },
		{ field: 'mobileNo', headerName: 'Mobile No', width: 150, type: 'string' },
		{
			field: 'createdAt',
			headerName: 'Lead Date',
			width: 180,
			type: 'string',
			valueGetter: createdAtDate,
		},
		{
			field: 'updatedAt',
			headerName: 'Update Date',
			width: 180,
			type: 'string',
			valueGetter: updatedAtDate,
		},
		{ field: 'followupStatus', headerName: 'Follow Up Status', width: 150, type: 'string' },
		{
			field: 'actions',
			headerName: 'Actions',
			width: 100,
			type: 'actions',
			renderCell: (params: GridRowParams) => (
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<IconButton onClick={() => handleVisibleProduct(params.row)}>
						<VisibilityIcon />
					</IconButton>

					{location?.includes(slug as string) && permmission?.edit ? (
						<IconButton onClick={() => handleEditProduct(params.row)}>
							<EditIcon />
						</IconButton>
					) : (
						!location.includes(slug as string) && (
							<IconButton onClick={() => handleEditProduct(params.row)}>
								<EditIcon />
							</IconButton>
						)
					)}
				</div>
			),
		},
	];

	return (
		<Container>
			<div
				className="d-flex"
				style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
			>
				<div>
					{!location.includes(slug as string) && (
						<Typography
							gutterBottom
							style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
						>
							Whole sale
						</Typography>
					)}
					<span
						style={{
							fontFamily: 'Poppins',
							fontWeight: '400',
							fontSize: '14px',
							color: '#006D48',
						}}
					>
						Manage your wholesale enquiries list, new wholesale enquiries, and more.
					</span>
				</div>
			</div>
			<Grid container spacing={2} alignItems="center" sx={{ mb: 2, mt: 2 }}>
				<Grid size={{ xs: 12, sm: 12, md: 12 }}>
					<TextField
						label="Search"
						variant="outlined"
						margin="none"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						size="small"
						fullWidth
					/>
				</Grid>
			</Grid>
			<Box sx={{ height: 600, width: 'auto' }}>
				<StyledDataGrid
					rows={filteredContacts}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
					}}
					slots={{ toolbar: GridToolbar }}
					pageSizeOptions={[10]}
					getRowId={(row) => row._id}
				/>
			</Box>
			<Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<span>{!visibleEnquiry ? 'View Wholesale' : 'Edit Wholesale'}</span>
					<StyledCrossIconButton onClick={handleCloseDialog}>
						<CloseIcon />
					</StyledCrossIconButton>
				</DialogTitle>
				<DialogContent>
					<CreateContacts
						product={currentProduct}
						fetchData={fetchData}
						// onSubmit={handleFormSubmit}
						isDisabled={!visibleEnquiry}
						handleCloseDialog={handleCloseDialog}
					/>
				</DialogContent>
				{/* <DialogActions>
					<Button onClick={handleCloseDialog} color="primary">
						Cancel
					</Button>
					{visibleEnquiry && (
						<Button onClick={handleSaveContact} color="primary">
							Save
						</Button>
					)}
				</DialogActions> */}
			</Dialog>
		</Container>
	);
};

export default Wholesalepage;
